/* eslint-disable no-console */
import { io } from 'socket.io-client';
import store from '../store';

let socket = null;

export class SocketClient {
    /**
     * Initialize the socket client.
     *
     * @constructor
    */
    constructor() {
        this.url = process.env.VUE_APP_WS_URL;
        this.accessToken = window.$cookies.get('accessToken');
    }

    /**
     * Establish a connection to the socket server.
     *
     * @return {Promise.<Socket|undefined>} The socket client instance, or undefined if the connection failed.
     * @throws {Error} If the connection to the socket server failed.
     */
    async connect() {
        return new Promise(resolve => {
            if (
                this.url
                && this.accessToken
            ) {
                this.client = io(this.url, {
                    auth: { accessToken: this.accessToken },
                });
                this.client.on('connect', () => {
                    console.log('Socket client connected');
                    socket = this.client;
                    resolve(this.client);
                });
                this.client.on('GREETING', (data, callback) => {
                    console.log('Socket server event', data);
                    callback('Pong');
                });
                this.client.on('MAINTENANCE', data => {
                    store.dispatch('setMaintenanceData', { ...data, show: true });
                });
                this.client.on('disconnect', reason => {
                    console.log('Socket client disconnected ', reason);
                });
                this.client.on('connect_error', error => {
                    if (socket?.active) {
                        // temporary failure, the socket will automatically try to reconnect
                        console.log(
                            'Socket client connection failed',
                            error.message,
                        );
                    } else {
                        // the connection was denied by the server
                        // in that case, `socket.connect()` must be manually called in order to reconnect
                        console.log(
                            'Socket client connection denied',
                            error.message,
                        );
                    }
                    resolve(null);
                });
            } else {
                console.log('Missing connection params');
                resolve(null);
            }
        });
    }
}

/**
 * Returns the current socket client instance.
 * You can use it to access socket client from other files
 *
 * @return {object|null} The socket client instance, or null if not connected.
 */
export const getSocketClient = () => socket;
export const initSocketClient = async () => {
    if (!socket) {
        const socketClient = new SocketClient();
        await socketClient.connect();
    }
};
